/* I13C in DS */ import React from 'react';
import IconWrap from '../../IconWrap';
const ArrowUp = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.29289 14.2426L11.2426 9.29289C11.6332 8.90237 12.2663 8.90237 12.6569 9.29289L17.6066 14.2426C17.9971 14.6332 17.9971 15.2663 17.6066 15.6569C17.2161 16.0474 16.5829 16.0474 16.1924 15.6569L11.949 11.4147L7.70711 15.6569C7.31658 16.0474 6.68342 16.0474 6.29289 15.6569C5.90237 15.2663 5.90237 14.6332 6.29289 14.2426Z"
    })));
};
ArrowUp.displayName = 'ArrowUp';
export default ArrowUp;

//# sourceMappingURL=ArrowUp.js.map